// extracted by mini-css-extract-plugin
module.exports = {"button":"GetTicketsButton_button__Pkr5Q","subscriptionButton":"GetTicketsButton_subscriptionButton__TqZyX"};